import { createBrowserRouter } from "react-router-dom";
import Layout from "./components/layout";
import ChatUI from "./chat";
import BubbleLayout from "./bubbleLayout";
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <ChatUI isBubble={false} parentUrl={""} />,
      },
      {
        path: "/chat-widget",
        element: <BubbleLayout />,
      },
    ],
  },
  {
    path: "*",
    element: (
      <div className="flex justify-center h-screen items-center">
        <div>
          <p className="text-5xl">404</p>
          <p>Not found</p>
        </div>
      </div>
    ),
  },
]);
